const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['加班', '加班', '加班'],
				children: {
					ZZ_POJENHC_AM10010: {
						name: ['(客製)批次轉成加班費', '(客製)批次轉成加班費', '(客製)批次轉成加班費'],
						url: '/zz_pojenhc_am10010',
						hint: [],
					},
				},
			},
			ZZ2: {
				name: ['請假', '請假', '請假'],
				children: {
					ZZ_POJENHC_AM10020: {
						name: ['(客製)保證時數查詢', '(客製)保證時數查詢', '(客製)保證時數查詢'],
						url: '/zz_pojenhc_am10020',
						hint: [],
					},
				},
			},
			ZZ3: {
				name: ['薪資', '薪資', '薪資'],
				children: {
					ZZ_POJENHC_PB00100: {
						name: ['(客製)節金/巡迴津貼查詢', '(客製)節金/巡迴津貼查詢', '(客製)節金/巡迴津貼查詢'],
						url: '/zz_pojenhc_pb00100',
						children: {
							ZZ_POJENHC_PB00100: { name: ['出勤場次', '出勤場次', '出勤場次'] },
							ZZ_POJENHC_PB00101: { name: ['超音波場次', '超音波場次', '超音波場次'] },
							ZZ_POJENHC_PB00102: { name: ['特殊時段計薪', '特殊時段計薪', '特殊時段計薪'] },
						},
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};